import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading } from '@americanexpress/dls-react';

const DisplayContactInfo = () => {
  const reqParams = JSON.parse(sessionStorage.getItem('reqParams'));
  const buyerId = reqParams?.buyer_id;

  if (buyerId) {
    return (
      <div className="pad dls-white-bg">
        <p>
          <FormattedMessage id="contactBID1" />
        </p>
        <Heading headingStyle="heading1" level={1} className="dls-gray-05">
          <FormattedMessage id="contactBIDAvail" />
        </Heading>
        <p>
          <FormattedMessage id="contactBID2" />
          <a href="mailto: amexcpgservicing@aexp.com">
            {' '}
            <FormattedMessage id="emailBID" />
            {' '}
          </a>
        </p>
      </div>
    );
  }

  return (
    <div className="pad dls-white-bg">
      <p>
        <FormattedMessage id="contactNoBID1" />
      </p>
      <Heading headingStyle="heading1" level={1} className="dls-gray-05">
        <FormattedMessage id="contactNoBIDAvail" />
      </Heading>
      <p>
        <FormattedMessage id="contactNoBID2" />
      </p>
    </div>
  );
};

export default DisplayContactInfo;
